// extracted by mini-css-extract-plugin
export default {"services":"service_services__xEl1E","service":"service_service__YPz2E"};